var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteSuccessSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success (1) 1",
    clipPath: "url(#clip0_5109_56965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5294 0.755859L19.4496 3.66862L22.8557 4.62561L20.6364 7.32113L20.8212 10.8869L17.5294 9.57852L14.2376 10.8869L14.4224 7.32113L12.2031 4.62561L15.6092 3.66862L17.5294 0.755859Z",
    stroke: "#85242D",
    strokeWidth: 1.75443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4684 21.4999C19.5242 21.4999 21.1908 19.8333 21.1908 17.7775C21.1908 15.7217 19.5242 14.0552 17.4684 14.0552C15.4126 14.0552 13.7461 15.7217 13.7461 17.7775C13.7461 19.8333 15.4126 21.4999 17.4684 21.4999Z",
    stroke: "#535862",
    strokeWidth: 1.75443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.5327 15.5359V17.508C29.5327 21.6116 27.4948 25.2726 24.3709 27.4734V34.3301H10.5602V27.416C7.5103 25.2393 5.52148 21.6709 5.52148 17.6377V15.5359C5.52148 14.3313 6.49835 13.3545 7.70198 13.3545C8.90555 13.3545 9.88337 14.3304 9.88337 15.5359V17.6774C9.88337 21.8975 13.3062 25.3207 17.5275 25.3207C21.7486 25.3207 25.1708 21.8975 25.1708 17.6774V15.5359C25.1708 14.3313 26.1476 13.3545 27.3513 13.3545H27.3523C28.5559 13.3545 29.5327 14.3314 29.5327 15.5359Z",
    stroke: "#535862",
    strokeWidth: 1.75443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.10156 5.24854L10.1009 9.24795",
    stroke: "#454B54",
    strokeWidth: 1.50771,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.1992 9.25381L29.1986 5.25439",
    stroke: "#454B54",
    strokeWidth: 1.50771,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5109_56965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSuccessSvg);
export default __webpack_public_path__ + "static/media/InviteSuccessSvg.80c4d68a9887f5c649d97883a5e02ab2.svg";
export { ForwardRef as ReactComponent };